import { BoxConsumableDetailsEntity } from "@modules/boxConsumable/entities/boxConsumableDetailsEntity"
import { BoxConsumableStatus } from "@modules/boxConsumable/entities/boxConsumableType"
import { BoxPurchasesDto } from "@modules/boxPurchases/gateway/boxPurchasesApiDto"
import { BoxSubscriptionDetailsEntity } from "@modules/boxSubscription/entities/boxSubscriptionDetailsEntity"
import { BoxSubscriptionStatus } from "@modules/boxSubscription/gateway/boxSubscriptionApiDto"

type BoxPurchasesState = Omit<BoxPurchasesEntity, "getActives" | "getPendings" | "getExpireds">
export class BoxPurchasesEntity {
  subscriptions: BoxSubscriptionDetailsEntity[]
  consumables: BoxConsumableDetailsEntity[]

  private constructor(boxPurchases: BoxPurchasesState) {
    this.subscriptions = boxPurchases.subscriptions
    this.consumables = boxPurchases.consumables
  }

  static fromDto(boxPurchasesDto: BoxPurchasesDto): BoxPurchasesEntity {
    const subscriptions = boxPurchasesDto.subscriptions.map((subscription) =>
      BoxSubscriptionDetailsEntity.fromDto(subscription),
    )
    const consumables = boxPurchasesDto.consumables.map((consumable) => BoxConsumableDetailsEntity.fromDto(consumable))
    return new BoxPurchasesEntity({ subscriptions, consumables })
  }

  getActives() {
    const activeConsumables = this.consumables.filter((consumable) => consumable.count !== null && consumable.count > 0)

    const activeSubscriptions = this.subscriptions.filter((subscription) =>
      [
        BoxSubscriptionStatus.ACTIVE,
        BoxSubscriptionStatus.PAUSE,
        BoxSubscriptionStatus.SCHEDULED_ACTIVATION,
        BoxSubscriptionStatus.PENDING_CANCELLATION,
        BoxSubscriptionStatus.NEW_BILLING_DATE,
        BoxSubscriptionStatus.PROCESSING_PAYMENT,
        BoxSubscriptionStatus.PAYMENT_IN_ERROR,
      ].includes(subscription.status),
    )
    return { activeConsumables, activeSubscriptions }
  }

  getPendings() {
    return { pendingConsumables: [], pendingSubscriptions: [] }
  }

  getExpireds() {
    const expiredConsumables = this.consumables.filter(
      (consumable) => consumable.status === BoxConsumableStatus.PAID && consumable.count === 0,
    )
    const expiredSubscriptions = this.subscriptions.filter(
      (subscription) => subscription.status === BoxSubscriptionStatus.INACTIVE,
    )
    return { expiredConsumables, expiredSubscriptions }
  }
}
